import React, { useState, useEffect } from "react";
// import { db } from "./firebase";
import { getFirestore, collection, query, where, onSnapshot } from "firebase/firestore";
import { Card, Button, Modal, Table } from "react-bootstrap";
import { getAuth } from "firebase/auth";

const MyMessages = () => {
  const [myMessages, setMyMessages] = useState([]);
  const [userIdd, setUserIdd] = useState('');
  const [selectedAmplifiers, setSelectedAmplifiers] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false);


  const auth = getAuth();
  const db = getFirestore(); // Firestore instance
  const user = auth.currentUser;

  // Open modal to view amplifiers information
  const handleInfoClick = (amplifiers) => {
    setSelectedAmplifiers(amplifiers);
    setShowInfoModal(true);
  };

  useEffect(() => {
    if (user) {
      const userId = user.uid;
      setUserIdd(userId)
      const q = query(
        collection(db, "messages"),
        where("authorId", "==", userId) // Replace with current user ID
      );
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const fetchedMessages = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMyMessages(fetchedMessages);
      });
      return () => unsubscribe();
    }
    
  }, [userIdd, user, db, auth]);

   // Parse amplifiers to get location counts
   const parseAmplifiers = (amplifiers) => {
    const locationCounts = {};
    amplifiers.forEach((entry) => {
      const [, location] = entry.split("&");
      if (locationCounts[location]) {
        locationCounts[location]++;
      } else {
        locationCounts[location] = 1;
      }
    });
    return Object.entries(locationCounts).map(([location, count]) => ({ location, count }));
  };

  return (
    <div className="container mt-5">
      <h3 className="text-center mb-4">My Messages</h3>
      <div className="row">
        {myMessages.length > 0 ? (
          myMessages.map((msg) => (
            <div key={msg.id} className="col-md-6 col-lg-4 mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <Card.Text className="mb-3 text-muted">
                    <i>{msg.content}</i>
                  </Card.Text>
                  <p className="text-muted small mb-3">
                    Amplified by <strong>{msg.amplifiers.length}</strong> people
                  </p>
                  <Button
                    onClick={() => handleInfoClick(msg.amplifiers || [])}
                    variant="light"
                    className="w-100"
                  >
                    <img src="./person2.png" width="22" alt="amplifiers" /> channels
                  </Button>
                </Card.Body>
              </Card>
            </div>
          ))
        ) : (
          <div className="text-center mt-5">
            <p className="text-muted">You haven't sent any messages to Mother Earth yet.</p>
          </div>
        )}
      </div>

      <Modal show={showInfoModal} onHide={() => setShowInfoModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Earth Channels Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAmplifiers.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {parseAmplifiers(selectedAmplifiers).map(({ location, count }) => (
                  <tr key={location}>
                    <td>{location}</td>
                    <td>{count}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p className="text-center text-muted">No Channels yet.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowInfoModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MyMessages;
